import { Validators } from "@angular/forms";
import { LayerType, sharedForms } from "../layer.model";
import { FormType, POIGlowProperties, Properties, WaterProperties } from "../properties.model";

export const poiForm: Properties = {
  propertyType: LayerType.POIGlow,
  label: 'POI Glow Layer',
  forms:
    sharedForms.concat([
    {
      id: POIGlowProperties.POIGlowColor,
      label: 'Glow Color Gradient',
      type: FormType.Gradient,
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: POIGlowProperties.POIGlowWidth,
      label: 'Glow Width',
      type: FormType.SliderNumber,
      defaultValue: 1,
      hint: "Modify how far a glow will reach",
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: POIGlowProperties.POIGlowStrength,
      label: 'Shadow Strength',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
  ]),
  changeHandler: () => {},
}
